// Hero content for the Workspace Dashboard:
// - time-of-day greeting variants (EN/PL/DE), picked per visit
// - a collection of 100 daily quotes (EN/PL/DE), rotating once per day

export const GREETINGS = {
  en: {
    morning: [
      'Good morning, {name}.',
      'Ready to create?',
      'Let\u2019s make something beautiful today.',
      'A calm beginning creates meaningful work.',
      'One beautiful idea is enough.',
    ],
    afternoon: [
      'Good afternoon, {name}.',
      'Welcome back.',
      'Continue where inspiration left you.',
      'Small steps become beautiful work.',
      'Everything is in one calm place.',
    ],
    evening: [
      'Good evening, {name}.',
      'Reflect. Create. Continue.',
      'Your ideas are waiting.',
      'Beautiful work takes time.',
      'End the day with clarity.',
    ],
  },
  pl: {
    morning: [
      'Dzie\u0144 dobry, {name}.',
      'Gotowa tworzy\u0107?',
      'Stw\u00f3rzmy dzi\u015b co\u015b pi\u0119knego.',
      'Spokojny pocz\u0105tek tworzy znacz\u0105c\u0105 prac\u0119.',
      'Jeden pi\u0119kny pomys\u0142 wystarczy.',
    ],
    afternoon: [
      'Dzie\u0144 dobry, {name}.',
      'Witaj z powrotem.',
      'Kontynuuj tam, gdzie zostawi\u0142a Ci\u0119 inspiracja.',
      'Ma\u0142e kroki staj\u0105 si\u0119 pi\u0119kn\u0105 prac\u0105.',
      'Wszystko w jednym spokojnym miejscu.',
    ],
    evening: [
      'Dobry wiecz\u00f3r, {name}.',
      'Pomy\u015bl. Tw\u00f3rz. Kontynuuj.',
      'Twoje pomys\u0142y czekaj\u0105.',
      'Pi\u0119kna praca wymaga czasu.',
      'Zako\u0144cz dzie\u0144 z jasno\u015bci\u0105.',
    ],
  },
  de: {
    morning: [
      'Guten Morgen, {name}.',
      'Bereit, etwas zu erschaffen?',
      'Lass uns heute etwas Sch\u00f6nes gestalten.',
      'Ein ruhiger Anfang schafft bedeutende Arbeit.',
      'Eine sch\u00f6ne Idee gen\u00fcgt.',
    ],
    afternoon: [
      'Guten Tag, {name}.',
      'Willkommen zur\u00fcck.',
      'Mach dort weiter, wo die Inspiration dich verlassen hat.',
      'Kleine Schritte werden zu sch\u00f6ner Arbeit.',
      'Alles an einem ruhigen Ort.',
    ],
    evening: [
      'Guten Abend, {name}.',
      'Reflektieren. Erschaffen. Weitermachen.',
      'Deine Ideen warten.',
      'Sch\u00f6ne Arbeit braucht Zeit.',
      'Beende den Tag mit Klarheit.',
    ],
  },
};

export const QUOTES = {
  en: [
    'Creativity is not a luxury. It\u2019s a way of life.',
    'Every masterpiece begins with a single idea.',
    'Beauty starts with intention.',
    'Great work grows quietly.',
    'Inspiration loves prepared minds.',
    'Simplicity is the ultimate sophistication.',
    'Less noise. More creation.',
    'Create with purpose.',
    'Small ideas become meaningful projects.',
    'Your work deserves a calm place.',
    'Progress is built one decision at a time.',
    'Organize less. Create more.',
    'Calm minds create beautiful things.',
    'Everything begins with one note.',
    'Capture first. Organize later.',
    'Ideas deserve a home.',
    'One place. Every idea.',
    'Create without carrying everything in your head.',
    'Your memory deserves support.',
    'Beautiful work starts behind the scenes.',
    'Every project has a story.',
    'Creativity grows in calm spaces.',
    'Timeless work begins with thoughtful details.',
    'Less chaos. More meaning.',
    'Your creative world. Beautifully organized.',
    'Build slowly. Build beautifully.',
    'Meaning lives in details.',
    'Calm is productive.',
    'Beautiful systems create beautiful work.',
    'Create.',
    'Continue.',
    'Stay curious.',
    'Trust the process.',
    'Keep building.',
    'One step today.',
    'Less clutter.',
    'More meaning.',
    'One idea at a time.',
    'Welcome back.',
    'Harmony over chaos.',
    'Silence is part of the composition.',
    'Elegance is the art of leaving out.',
    'Good things take time and attention.',
    'Order is not a limit. It is freedom.',
    'Inspiration returns when it has somewhere to return to.',
    'Create the way you breathe \u2014 calmly, at your own pace.',
    'A clear space invites a clear mind.',
    'The quiet hours shape the finest work.',
    'Every detail is a decision.',
    'Begin gently. Finish beautifully.',
    'What you collect today becomes tomorrow\u2019s idea.',
    'Craft is patience made visible.',
    'Taste is knowing what to remove.',
    'The best ideas arrive unhurried.',
    'Care is the rarest material.',
    'A calm workspace is a quiet superpower.',
    'Style is consistency in small things.',
    'Make room for what matters.',
    'Your attention is your finest tool.',
    'Slow is smooth. Smooth is beautiful.',
    'Every client is a story worth remembering.',
    'Trust grows in well-kept places.',
    'Details are how you say you care.',
    'What is beautiful is rarely loud.',
    'Light, space and intention \u2014 the rest follows.',
    'First clarity, then creation.',
    'Keep the vision. Release the noise.',
    'A gathered mind gathers beauty.',
    'Nothing precious is made in a hurry.',
    'Curate your world like a gallery.',
    'Great taste is quiet confidence.',
    'The unseen work makes the seen work shine.',
    'Refine, don\u2019t rush.',
    'Let your work breathe.',
    'Save the idea before it fades.',
    'A single image can start everything.',
    'Collect beauty wherever you find it.',
    'Today\u2019s note is tomorrow\u2019s masterpiece.',
    'Memory is a creative tool.',
    'Archives are love letters to your future self.',
    'What you finish today becomes your legacy.',
    'Beauty rewards the patient.',
    'Choose depth over speed.',
    'An honest craft never goes out of style.',
    'Your calm is contagious \u2014 clients feel it.',
    'Presentation is part of the gift.',
    'Every board tells a story before you say a word.',
    'Make it simple, make it lasting.',
    'Quality whispers.',
    'The right mood changes everything.',
    'Begin with one true thing.',
    'Keep your promises to your ideas.',
    'Rest is part of the process.',
    'Beautiful endings are planned beginnings.',
    'Your style is a sum of your choices.',
    'Softness is a strength.',
    'Tomorrow\u2019s inspiration thanks today\u2019s order.',
    'What matters, deserves a place.',
    'Let today be well-composed.',
    'You are the calm in your creative storm.',
  ],
  pl: [
    'Kreatywno\u015b\u0107 to nie luksus. To spos\u00f3b na \u017cycie.',
    'Ka\u017cde arcydzie\u0142o zaczyna si\u0119 od jednego pomys\u0142u.',
    'Pi\u0119kno zaczyna si\u0119 od intencji.',
    'Wielka praca ro\u015bnie w ciszy.',
    'Inspiracja kocha przygotowane umys\u0142y.',
    'Prostota jest szczytem wyrafinowania.',
    'Mniej szumu. Wi\u0119cej tworzenia.',
    'Tw\u00f3rz z zamys\u0142em.',
    'Ma\u0142e pomys\u0142y staj\u0105 si\u0119 znacz\u0105cymi projektami.',
    'Twoja praca zas\u0142uguje na spokojne miejsce.',
    'Post\u0119p buduje si\u0119 jedn\u0105 decyzj\u0105 na raz.',
    'Mniej organizuj. Wi\u0119cej tw\u00f3rz.',
    'Spokojne umys\u0142y tworz\u0105 pi\u0119kne rzeczy.',
    'Wszystko zaczyna si\u0119 od jednej notatki.',
    'Najpierw uchwy\u0107. Porz\u0105dkuj p\u00f3\u017aniej.',
    'Pomys\u0142y zas\u0142uguj\u0105 na dom.',
    'Jedno miejsce. Ka\u017cdy pomys\u0142.',
    'Tw\u00f3rz bez noszenia wszystkiego w g\u0142owie.',
    'Twoja pami\u0119\u0107 zas\u0142uguje na wsparcie.',
    'Pi\u0119kna praca zaczyna si\u0119 za kulisami.',
    'Ka\u017cdy projekt ma swoj\u0105 histori\u0119.',
    'Kreatywno\u015b\u0107 ro\u015bnie w spokojnych przestrzeniach.',
    'Ponadczasowa praca zaczyna si\u0119 od przemy\u015blanych detali.',
    'Mniej chaosu. Wi\u0119cej znaczenia.',
    'Tw\u00f3j tw\u00f3rczy \u015bwiat. Pi\u0119knie uporz\u0105dkowany.',
    'Buduj powoli. Buduj pi\u0119knie.',
    'Znaczenie mieszka w detalach.',
    'Spok\u00f3j jest produktywny.',
    'Pi\u0119kne systemy tworz\u0105 pi\u0119kn\u0105 prac\u0119.',
    'Tw\u00f3rz.',
    'Kontynuuj.',
    'Pozosta\u0144 ciekawa.',
    'Zaufaj procesowi.',
    'Buduj dalej.',
    'Jeden krok dzisiaj.',
    'Mniej ba\u0142aganu.',
    'Wi\u0119cej znaczenia.',
    'Jeden pomys\u0142 na raz.',
    'Witaj z powrotem.',
    'Harmonia ponad chaosem.',
    'Cisza jest cz\u0119\u015bci\u0105 kompozycji.',
    'Elegancja to sztuka pomijania.',
    'Dobre rzeczy wymagaj\u0105 czasu i uwagi.',
    'Porz\u0105dek to nie ograniczenie. To wolno\u015b\u0107.',
    'Inspiracja wraca, gdy ma dok\u0105d wr\u00f3ci\u0107.',
    'Tw\u00f3rz tak, jak oddychasz \u2014 spokojnie, we w\u0142asnym rytmie.',
    'Czysta przestrze\u0144 zaprasza czysty umys\u0142.',
    'Ciche godziny kszta\u0142tuj\u0105 najlepsz\u0105 prac\u0119.',
    'Ka\u017cdy detal to decyzja.',
    'Zacznij \u0142agodnie. Sko\u0144cz pi\u0119knie.',
    'To, co dzi\u015b zbierzesz, jutro stanie si\u0119 pomys\u0142em.',
    'Rzemios\u0142o to cierpliwo\u015b\u0107, kt\u00f3r\u0105 wida\u0107.',
    'Gust to wiedzie\u0107, co usun\u0105\u0107.',
    'Najlepsze pomys\u0142y przychodz\u0105 niespiesznie.',
    'Troska to najrzadszy materia\u0142.',
    'Spokojna przestrze\u0144 pracy to cicha supermoc.',
    'Styl to konsekwencja w ma\u0142ych rzeczach.',
    'Zr\u00f3b miejsce na to, co wa\u017cne.',
    'Twoja uwaga to Twoje najlepsze narz\u0119dzie.',
    'Powoli znaczy p\u0142ynnie. P\u0142ynnie znaczy pi\u0119knie.',
    'Ka\u017cdy klient to historia warta zapami\u0119tania.',
    'Zaufanie ro\u015bnie w zadbanych miejscach.',
    'Detale to spos\u00f3b, w jaki m\u00f3wisz \u201ezale\u017cy mi\u201d.',
    'To, co pi\u0119kne, rzadko bywa g\u0142o\u015bne.',
    '\u015awiat\u0142o, przestrze\u0144 i intencja \u2014 reszta przyjdzie sama.',
    'Najpierw jasno\u015b\u0107, potem tworzenie.',
    'Zachowaj wizj\u0119. Odpu\u015b\u0107 szum.',
    'Skupiony umys\u0142 gromadzi pi\u0119kno.',
    'Nic cennego nie powstaje w po\u015bpiechu.',
    'Kuratoruj sw\u00f3j \u015bwiat jak galeri\u0119.',
    'Dobry gust to cicha pewno\u015b\u0107 siebie.',
    'Niewidoczna praca sprawia, \u017ce widoczna l\u015bni.',
    'Dopracowuj, nie przyspieszaj.',
    'Pozw\u00f3l swojej pracy oddycha\u0107.',
    'Zapisz pomys\u0142, zanim zniknie.',
    'Jeden obraz mo\u017ce rozpocz\u0105\u0107 wszystko.',
    'Zbieraj pi\u0119kno, gdziekolwiek je znajdziesz.',
    'Dzisiejsza notatka to jutrzejsze arcydzie\u0142o.',
    'Pami\u0119\u0107 to narz\u0119dzie tw\u00f3rcze.',
    'Archiwa to listy mi\u0142osne do przysz\u0142ej siebie.',
    'To, co dzi\u015b sko\u0144czysz, stanie si\u0119 Twoim dziedzictwem.',
    'Pi\u0119kno nagradza cierpliwych.',
    'Wybieraj g\u0142\u0119bi\u0119 zamiast po\u015bpiechu.',
    'Uczciwe rzemios\u0142o nigdy nie wychodzi z mody.',
    'Tw\u00f3j spok\u00f3j jest zara\u017aliwy \u2014 klienci go czuj\u0105.',
    'Prezentacja jest cz\u0119\u015bci\u0105 podarunku.',
    'Ka\u017cda tablica opowiada histori\u0119, zanim powiesz s\u0142owo.',
    'Zr\u00f3b to prosto, zr\u00f3b to trwale.',
    'Jako\u015b\u0107 m\u00f3wi szeptem.',
    'W\u0142a\u015bciwy nastr\u00f3j zmienia wszystko.',
    'Zacznij od jednej prawdziwej rzeczy.',
    'Dotrzymuj obietnic swoim pomys\u0142om.',
    'Odpoczynek jest cz\u0119\u015bci\u0105 procesu.',
    'Pi\u0119kne zako\u0144czenia to zaplanowane pocz\u0105tki.',
    'Tw\u00f3j styl to suma Twoich wybor\u00f3w.',
    'Delikatno\u015b\u0107 jest si\u0142\u0105.',
    'Jutrzejsza inspiracja podzi\u0119kuje za dzisiejszy porz\u0105dek.',
    'To, co wa\u017cne, zas\u0142uguje na swoje miejsce.',
    'Niech dzisiejszy dzie\u0144 b\u0119dzie dobrze skomponowany.',
    'Jeste\u015b spokojem w swojej tw\u00f3rczej burzy.',
  ],
  de: [
    'Kreativit\u00e4t ist kein Luxus. Sie ist eine Lebensart.',
    'Jedes Meisterwerk beginnt mit einer einzigen Idee.',
    'Sch\u00f6nheit beginnt mit Absicht.',
    'Gro\u00dfe Arbeit w\u00e4chst leise.',
    'Inspiration liebt vorbereitete K\u00f6pfe.',
    'Einfachheit ist die h\u00f6chste Raffinesse.',
    'Weniger L\u00e4rm. Mehr Sch\u00f6pfung.',
    'Erschaffe mit Absicht.',
    'Kleine Ideen werden zu bedeutenden Projekten.',
    'Deine Arbeit verdient einen ruhigen Ort.',
    'Fortschritt entsteht Entscheidung f\u00fcr Entscheidung.',
    'Weniger organisieren. Mehr erschaffen.',
    'Ruhige K\u00f6pfe erschaffen sch\u00f6ne Dinge.',
    'Alles beginnt mit einer Notiz.',
    'Erst festhalten. Sp\u00e4ter ordnen.',
    'Ideen verdienen ein Zuhause.',
    'Ein Ort. Jede Idee.',
    'Erschaffe, ohne alles im Kopf zu tragen.',
    'Dein Ged\u00e4chtnis verdient Unterst\u00fctzung.',
    'Sch\u00f6ne Arbeit beginnt hinter den Kulissen.',
    'Jedes Projekt hat eine Geschichte.',
    'Kreativit\u00e4t w\u00e4chst in ruhigen R\u00e4umen.',
    'Zeitlose Arbeit beginnt mit durchdachten Details.',
    'Weniger Chaos. Mehr Bedeutung.',
    'Deine kreative Welt. Wundersch\u00f6n geordnet.',
    'Baue langsam. Baue sch\u00f6n.',
    'Bedeutung wohnt im Detail.',
    'Ruhe ist produktiv.',
    'Sch\u00f6ne Systeme schaffen sch\u00f6ne Arbeit.',
    'Erschaffe.',
    'Mach weiter.',
    'Bleib neugierig.',
    'Vertraue dem Prozess.',
    'Bau weiter.',
    'Ein Schritt heute.',
    'Weniger Unordnung.',
    'Mehr Bedeutung.',
    'Eine Idee nach der anderen.',
    'Willkommen zur\u00fcck.',
    'Harmonie \u00fcber Chaos.',
    'Stille ist Teil der Komposition.',
    'Eleganz ist die Kunst des Weglassens.',
    'Gute Dinge brauchen Zeit und Aufmerksamkeit.',
    'Ordnung ist keine Grenze. Sie ist Freiheit.',
    'Inspiration kehrt zur\u00fcck, wenn sie einen Ort daf\u00fcr hat.',
    'Erschaffe, wie du atmest \u2014 ruhig, in deinem eigenen Rhythmus.',
    'Ein klarer Raum l\u00e4dt einen klaren Geist ein.',
    'Die stillen Stunden formen die feinste Arbeit.',
    'Jedes Detail ist eine Entscheidung.',
    'Beginne sanft. Vollende sch\u00f6n.',
    'Was du heute sammelst, wird morgen zur Idee.',
    'Handwerk ist sichtbar gewordene Geduld.',
    'Geschmack hei\u00dft wissen, was man wegl\u00e4sst.',
    'Die besten Ideen kommen ohne Eile.',
    'Sorgfalt ist das seltenste Material.',
    'Ein ruhiger Arbeitsplatz ist eine stille Superkraft.',
    'Stil ist Best\u00e4ndigkeit in kleinen Dingen.',
    'Schaffe Raum f\u00fcr das, was z\u00e4hlt.',
    'Deine Aufmerksamkeit ist dein feinstes Werkzeug.',
    'Langsam ist flie\u00dfend. Flie\u00dfend ist sch\u00f6n.',
    'Jeder Kunde ist eine Geschichte, die es wert ist, erinnert zu werden.',
    'Vertrauen w\u00e4chst an gepflegten Orten.',
    'Details sind deine Art zu sagen, dass es dir wichtig ist.',
    'Was sch\u00f6n ist, ist selten laut.',
    'Licht, Raum und Absicht \u2014 der Rest folgt.',
    'Erst Klarheit, dann Sch\u00f6pfung.',
    'Bewahre die Vision. Lass den L\u00e4rm los.',
    'Ein gesammelter Geist sammelt Sch\u00f6nheit.',
    'Nichts Kostbares entsteht in Eile.',
    'Kuratiere deine Welt wie eine Galerie.',
    'Guter Geschmack ist stilles Selbstvertrauen.',
    'Die unsichtbare Arbeit l\u00e4sst die sichtbare gl\u00e4nzen.',
    'Verfeinern, nicht hetzen.',
    'Lass deine Arbeit atmen.',
    'Halte die Idee fest, bevor sie verblasst.',
    'Ein einziges Bild kann alles beginnen.',
    'Sammle Sch\u00f6nheit, wo immer du sie findest.',
    'Die Notiz von heute ist das Meisterwerk von morgen.',
    'Erinnerung ist ein kreatives Werkzeug.',
    'Archive sind Liebesbriefe an dein zuk\u00fcnftiges Ich.',
    'Was du heute vollendest, wird dein Verm\u00e4chtnis.',
    'Sch\u00f6nheit belohnt die Geduldigen.',
    'W\u00e4hle Tiefe statt Tempo.',
    'Ehrliches Handwerk kommt nie aus der Mode.',
    'Deine Ruhe ist ansteckend \u2014 Kunden sp\u00fcren sie.',
    'Pr\u00e4sentation ist Teil des Geschenks.',
    'Jedes Board erz\u00e4hlt eine Geschichte, bevor du ein Wort sagst.',
    'Mach es einfach, mach es best\u00e4ndig.',
    'Qualit\u00e4t fl\u00fcstert.',
    'Die richtige Stimmung ver\u00e4ndert alles.',
    'Beginne mit einer wahren Sache.',
    'Halte die Versprechen an deine Ideen.',
    'Ruhe ist Teil des Prozesses.',
    'Sch\u00f6ne Enden sind geplante Anf\u00e4nge.',
    'Dein Stil ist die Summe deiner Entscheidungen.',
    'Sanftheit ist eine St\u00e4rke.',
    'Die Inspiration von morgen dankt der Ordnung von heute.',
    'Was wichtig ist, verdient einen Platz.',
    'M\u00f6ge der heutige Tag gut komponiert sein.',
    'Du bist die Ruhe in deinem kreativen Sturm.',
  ],
};

export function getPeriod(hour) {
  if (hour < 12) return 'morning';
  if (hour < 18) return 'afternoon';
  return 'evening';
}

export function pickGreeting(lang, period) {
  const pool = (GREETINGS[lang] || GREETINGS.en)[period] || GREETINGS.en.morning;
  return pool[Math.floor(Math.random() * pool.length)];
}

// Deterministic per local calendar day — same quote all day, new one tomorrow.
export function getDailyQuote(lang) {
  const list = QUOTES[lang] || QUOTES.en;
  const d = new Date();
  const seed = d.getFullYear() * 372 + d.getMonth() * 31 + d.getDate();
  return list[seed % list.length];
}
